import React from 'react';
import { GlobalStyle } from './components/StyledComponents';
import EventDashboard from './components/EventDashboard';

function App() {
  return (
    <>
      <GlobalStyle />
        <div className="App">
          <EventDashboard />
        </div>
    </>
  );
}

export default App;